// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2rlgi","title":"Info_title__2t3o6","links":"Info_links__1QA2r","link":"Info_link__3dqg7","logo":"Info_logo__3jyMt"};